// ============================================================
// STAYCLASSY PHONE FINDER DATA
// Edit this file to add/remove brands or models
// FORMAT: {"l":"Model Name","u":"/collections/collection-handle"}
// NOTE: Lines commented out below are models NOT present in the
// current OptionsExport CSV. Uncomment if you want to re-enable them.
// NOTE: iQOO is a SEPARATE brand key here. Make sure the Brand
// dropdown HTML (sc-phone-finder.liquid) has a separate
// <option value="iQOO">iQOO</option> - otherwise iQOO models wont show.
// ============================================================

var scfData = {

"Apple": [
{"l":"iPhone 18 Pro Max","u":"/collections/apple-iphone-18-pro-max-back-cover"},
{"l":"iPhone 18 Pro","u":"/collections/apple-iphone-18-pro-back-cover"},
{"l":"iPhone 17 Pro Max","u":"/collections/apple-iphone-17-pro-max-back-cover"},
{"l":"iPhone 17 Pro","u":"/collections/apple-iphone-17-pro-back-cover"},
{"l":"iPhone 17","u":"/collections/apple-iphone-17-back-cover"},
{"l":"iPhone 17 Air","u":"/collections/apple-iphone-17-air-back-cover"},
{"l":"iPhone 16 Pro Max","u":"/collections/apple-iphone-16-pro-max-back-cover"},
{"l":"iPhone 16 Pro","u":"/collections/apple-iphone-16-pro-back-cover"},
{"l":"iPhone 16 Plus","u":"/collections/apple-iphone-16-plus-back-cover"},
{"l":"iPhone 16E","u":"/collections/apple-iphone-16e-back-cover"},
{"l":"iPhone 16","u":"/collections/apple-iphone-16-back-cover"},
{"l":"iPhone 15 Pro Max","u":"/collections/apple-iphone-15-pro-max-back-cover"},
{"l":"iPhone 15 Pro","u":"/collections/apple-iphone-15-pro-back-cover"},
{"l":"iPhone 15 Plus","u":"/collections/apple-iphone-15-plus-back-cover"},
{"l":"iPhone 15","u":"/collections/apple-iphone-15-back-cover"},
{"l":"iPhone 14 Pro Max","u":"/collections/apple-iphone-14-pro-max-back-cover"},
{"l":"iPhone 14 Pro","u":"/collections/apple-iphone-14-pro-back-cover"},
{"l":"iPhone 14 Plus","u":"/collections/apple-iphone-14-plus-back-cover"},
{"l":"iPhone 14","u":"/collections/apple-iphone-14-back-cover"},
{"l":"iPhone 13 Pro Max","u":"/collections/apple-iphone-13-pro-max-back-cover"},
{"l":"iPhone 13 Pro","u":"/collections/apple-iphone-13-pro-back-cover"},
{"l":"iPhone 13 Mini","u":"/collections/apple-iphone-13-mini-back-cover"},
{"l":"iPhone 13","u":"/collections/apple-iphone-13-back-cover"},
{"l":"iPhone 12 Pro Max","u":"/collections/apple-iphone-12-pro-max-back-cover"},
{"l":"iPhone 12 Pro","u":"/collections/apple-iphone-12-pro-back-cover"},
{"l":"iPhone 12 Mini","u":"/collections/apple-iphone-12-mini-back-cover"},
{"l":"iPhone 12","u":"/collections/apple-iphone-12-back-cover"},
{"l":"iPhone 11 Pro Max","u":"/collections/apple-iphone-11-pro-max-back-cover"},
{"l":"iPhone 11 Pro","u":"/collections/apple-iphone-11-pro-back-cover"},
{"l":"iPhone 11","u":"/collections/apple-iphone-11-back-cover"},
{"l":"iPhone X","u":"/collections/apple-iphone-x-back-cover"},
{"l":"iPhone XR","u":"/collections/apple-iphone-xr-back-cover"},
{"l":"iPhone XS","u":"/collections/apple-iphone-xs-back-cover"},
{"l":"iPhone XS Max","u":"/collections/apple-iphone-xs-max-back-cover"},
{"l":"iPhone SE 2022","u":"/collections/apple-iphone-se-2022-back-cover"},
{"l":"iPhone SE 2020","u":"/collections/apple-iphone-se-2020-back-cover"},
{"l":"iPhone 8 Plus","u":"/collections/apple-iphone-8-plus-back-cover"},
{"l":"iPhone 8","u":"/collections/apple-iphone-8-back-cover"},
{"l":"iPhone 7 Plus","u":"/collections/apple-iphone-7-plus-back-cover"},
{"l":"iPhone 7","u":"/collections/apple-iphone-7-back-cover"},
],

"Samsung": [
{"l":"S26 Ultra","u":"/collections/samsung-s26-ultra-back-cover"},
{"l":"S26 Plus","u":"/collections/samsung-s26-plus-back-cover"},
{"l":"S26","u":"/collections/samsung-s26-back-cover"},
{"l":"S25 Edge","u":"/collections/samsung-s25-edge-back-cover"},
{"l":"S25 Ultra","u":"/collections/samsung-s25-ultra-back-cover"},
{"l":"S25 Plus","u":"/collections/samsung-s25-plus-back-cover"},
//{"l":"S25 FE","u":"/collections/samsung-s25-fe-back-cover"},
{"l":"S25","u":"/collections/samsung-s25-back-cover"},
{"l":"S24 Ultra","u":"/collections/samsung-s24-ultra-back-cover"},
{"l":"S24 Plus","u":"/collections/samsung-s24-plus-back-cover"},
{"l":"S24 FE","u":"/collections/samsung-s24-fe-back-cover"},
{"l":"S24","u":"/collections/samsung-s24-back-cover"},
{"l":"S23 Ultra","u":"/collections/samsung-s23-ultra-back-cover"},
{"l":"S23 Plus","u":"/collections/samsung-s23-plus-back-cover"},
{"l":"S23 FE","u":"/collections/samsung-s23-fe-back-cover"},
{"l":"S23","u":"/collections/samsung-s23-back-cover"},
{"l":"S22 Ultra","u":"/collections/samsung-s22-ultra-back-cover"},
{"l":"S22 Plus","u":"/collections/samsung-s22-plus-back-cover"},
{"l":"S22","u":"/collections/samsung-s22-back-cover"},
{"l":"S21 Ultra","u":"/collections/samsung-s21-ultra-back-cover"},
{"l":"S21 Plus","u":"/collections/samsung-s21-plus-back-cover"},
{"l":"S21 FE","u":"/collections/samsung-s21-fe-back-cover"},
{"l":"S21","u":"/collections/samsung-s21-back-cover"},
{"l":"S20 Ultra","u":"/collections/samsung-s20-ultra-back-cover"},
{"l":"S20 Plus","u":"/collections/samsung-s20-plus-back-cover"},
{"l":"S20 FE","u":"/collections/samsung-s20-fe-back-cover"},
{"l":"S20","u":"/collections/samsung-s20-back-cover"},
{"l":"Note 20 Ultra","u":"/collections/samsung-note-20-ultra-back-cover"},
{"l":"Note 20","u":"/collections/samsung-note-20-back-cover"},
{"l":"M62","u":"/collections/samsung-m62-back-cover"},
{"l":"M56","u":"/collections/samsung-m56-back-cover"},
{"l":"M55","u":"/collections/samsung-m55-back-cover"},
{"l":"M54","u":"/collections/samsung-m54-back-cover"},
{"l":"M53","u":"/collections/samsung-m53-back-cover"},
{"l":"M52","u":"/collections/samsung-m52-back-cover"},
{"l":"M51","u":"/collections/samsung-m51-back-cover"},
{"l":"M36","u":"/collections/samsung-m36-back-cover"},
{"l":"M35","u":"/collections/samsung-m35-back-cover"},
{"l":"M34","u":"/collections/samsung-m34-back-cover"},
{"l":"M33","u":"/collections/samsung-m33-back-cover"},
{"l":"M32 5G","u":"/collections/samsung-m32-5g-back-cover"},
{"l":"M32 4G","u":"/collections/samsung-m32-4g-back-cover"},
{"l":"M31 Prime","u":"/collections/samsung-m31-prime-back-cover"},
{"l":"M31S","u":"/collections/samsung-m31s-back-cover"},
{"l":"M31","u":"/collections/samsung-m31-back-cover"},
{"l":"M30S","u":"/collections/samsung-m30s-back-cover"},
{"l":"M23","u":"/collections/samsung-m23-back-cover"},
{"l":"M21","u":"/collections/samsung-m21-back-cover"},
{"l":"M17","u":"/collections/samsung-m17-back-cover"},
{"l":"M16","u":"/collections/samsung-m16-back-cover"},
{"l":"M15","u":"/collections/samsung-m15-back-cover"},
{"l":"M14 5G","u":"/collections/samsung-m14-5g-back-cover"},
{"l":"M12","u":"/collections/samsung-m12-back-cover"},
{"l":"M02S","u":"/collections/samsung-m02s-back-cover"},
{"l":"F62","u":"/collections/samsung-f62-back-cover"},
{"l":"F56","u":"/collections/samsung-f56-back-cover"},
{"l":"F55","u":"/collections/samsung-f55-back-cover"},
{"l":"F54","u":"/collections/samsung-f54-back-cover"},
{"l":"F42","u":"/collections/samsung-f42-back-cover"},
{"l":"F41","u":"/collections/samsung-f41-back-cover"},
{"l":"F36","u":"/collections/samsung-f36-back-cover"},
{"l":"F34","u":"/collections/samsung-f34-back-cover"},
{"l":"F23","u":"/collections/samsung-f23-back-cover"},
{"l":"F17","u":"/collections/samsung-f17-back-cover"},
{"l":"F16","u":"/collections/samsung-f16-back-cover"},
{"l":"F15","u":"/collections/samsung-f15-back-cover"},
{"l":"F14 5G","u":"/collections/samsung-f14-5g-back-cover"},
{"l":"A73","u":"/collections/samsung-a73-back-cover"},
{"l":"A72","u":"/collections/samsung-a72-back-cover"},
{"l":"A57","u":"/collections/samsung-a57-back-cover"},
{"l":"A56","u":"/collections/samsung-a56-back-cover"},
{"l":"A55","u":"/collections/samsung-a55-back-cover"},
{"l":"A54","u":"/collections/samsung-a54-back-cover"},
{"l":"A53","u":"/collections/samsung-a53-back-cover"},
{"l":"A52S","u":"/collections/samsung-a52s-back-cover"},
{"l":"A52","u":"/collections/samsung-a52-back-cover"},
{"l":"A37","u":"/collections/samsung-a37-back-cover"},
{"l":"A36","u":"/collections/samsung-a36-back-cover"},
{"l":"A35","u":"/collections/samsung-a35-back-cover"},
{"l":"A34","u":"/collections/samsung-a34-back-cover"},
{"l":"A33","u":"/collections/samsung-a33-back-cover"},
{"l":"A32 5G","u":"/collections/samsung-a32-5g-back-cover"},
{"l":"A32 4G","u":"/collections/samsung-a32-4g-back-cover"},
{"l":"A31","u":"/collections/samsung-a31-back-cover"},
//{"l":"A27","u":"/collections/samsung-a27-back-cover"},
{"l":"A26","u":"/collections/samsung-a26-back-cover"},
{"l":"A25","u":"/collections/samsung-a25-back-cover"},
{"l":"A23","u":"/collections/samsung-a23-back-cover"},
{"l":"A22 5G","u":"/collections/samsung-a22-5g-back-cover"},
{"l":"A22 4G","u":"/collections/samsung-a22-4g-back-cover"},
{"l":"A17","u":"/collections/samsung-a17-back-cover"},
{"l":"A16","u":"/collections/samsung-a16-back-cover"},
{"l":"A15","u":"/collections/samsung-a15-back-cover"},
{"l":"A14","u":"/collections/samsung-a14-back-cover"},
{"l":"A13 4G","u":"/collections/samsung-a13-4g-back-cover"},
{"l":"A12","u":"/collections/samsung-a12-back-cover"},
{"l":"A07","u":"/collections/samsung-a07-back-cover"},
{"l":"A06","u":"/collections/samsung-a06-back-cover"},
{"l":"A05s","u":"/collections/samsung-a05s-back-cover"},
// -- Not in OptionsExport CSV (kept, disabled) --
// {"l":"A13 5G","u":"/collections/samsung-a13-5g-back-cover"},
// {"l":"F04","u":"/collections/samsung-f04-back-cover"},
// {"l":"F05","u":"/collections/samsung-f05-back-cover"},
// {"l":"F12","u":"/collections/samsung-f12-back-cover"},
// {"l":"F13","u":"/collections/samsung-f13-back-cover"},
// {"l":"F14 4G","u":"/collections/samsung-f14-4g-back-cover"},
// {"l":"F22","u":"/collections/samsung-f22-back-cover"},
// {"l":"M04","u":"/collections/samsung-m04-back-cover"},
// {"l":"M13 4G","u":"/collections/samsung-m13-4g-back-cover"},
// {"l":"M13 5G","u":"/collections/samsung-m13-5g-back-cover"},
// {"l":"M14 4G","u":"/collections/samsung-m14-4g-back-cover"},
],

"OnePlus": [
{"l":"Nord CE 5","u":"/collections/oneplus-nord-ce-5-back-cover"},
{"l":"Nord CE 4 Lite","u":"/collections/oneplus-nord-ce-4-lite-back-cover"},
{"l":"Nord CE 4","u":"/collections/oneplus-nord-ce-4-back-cover"},
{"l":"Nord CE 3 Lite","u":"/collections/oneplus-nord-ce-3-lite-back-cover"},
{"l":"Nord CE 3","u":"/collections/oneplus-nord-ce-3-back-cover"},
{"l":"Nord CE 2 Lite","u":"/collections/oneplus-nord-ce-2-lite-back-cover"},
{"l":"Nord CE 2","u":"/collections/oneplus-nord-ce-2-back-cover"},
{"l":"Nord CE","u":"/collections/oneplus-nord-ce-back-cover"},
{"l":"Nord 5","u":"/collections/oneplus-nord-5-back-cover"},
{"l":"Nord 4","u":"/collections/oneplus-nord-4-back-cover"},
{"l":"Nord 3","u":"/collections/oneplus-nord-3-back-cover"},
{"l":"Nord 2T","u":"/collections/oneplus-nord-2t-back-cover"},
{"l":"Nord 2","u":"/collections/oneplus-nord-2-back-cover"},
{"l":"Nord","u":"/collections/oneplus-nord-back-cover"},
{"l":"OnePlus 15T","u":"/collections/oneplus-15t-back-cover"},
{"l":"OnePlus 15R","u":"/collections/oneplus-15r-back-cover"},
{"l":"OnePlus 15","u":"/collections/oneplus-15-back-cover"},
{"l":"OnePlus 13T","u":"/collections/oneplus-13t-back-cover"},
{"l":"OnePlus 13S","u":"/collections/oneplus-13s-back-cover"},
{"l":"OnePlus 13R","u":"/collections/oneplus-13r-back-cover"},
{"l":"OnePlus 13","u":"/collections/oneplus-13-back-cover"},
{"l":"OnePlus 12R","u":"/collections/oneplus-12r-back-cover"},
{"l":"OnePlus 12","u":"/collections/oneplus-12-back-cover"},
{"l":"OnePlus 11R","u":"/collections/oneplus-11r-back-cover"},
{"l":"OnePlus 11","u":"/collections/oneplus-11-back-cover"},
{"l":"OnePlus 10 Pro","u":"/collections/oneplus-10-pro-back-cover"},
{"l":"OnePlus 10T","u":"/collections/oneplus-10t-back-cover"},
{"l":"OnePlus 10R","u":"/collections/oneplus-10r-back-cover"},
{"l":"OnePlus 9 Pro","u":"/collections/oneplus-9-pro-back-cover"},
{"l":"OnePlus 9RT","u":"/collections/oneplus-9rt-back-cover"},
{"l":"OnePlus 9R","u":"/collections/oneplus-9r-back-cover"},
{"l":"OnePlus 9","u":"/collections/oneplus-9-back-cover"},
{"l":"OnePlus 8 Pro","u":"/collections/oneplus-8-pro-back-cover"},
{"l":"OnePlus 8T","u":"/collections/oneplus-8t-back-cover"},
{"l":"OnePlus 8","u":"/collections/oneplus-8-back-cover"},
{"l":"OnePlus 7T Pro","u":"/collections/oneplus-7t-pro-back-cover"},
{"l":"OnePlus 7 Pro","u":"/collections/oneplus-7-pro-back-cover"},
{"l":"OnePlus 7T","u":"/collections/oneplus-7t-back-cover"},
{"l":"OnePlus 7","u":"/collections/oneplus-7-back-cover"},
{"l":"OnePlus 6T","u":"/collections/oneplus-6t-back-cover"},
// -- Not in OptionsExport CSV (kept, disabled) --
],

"Google": [
{"l":"Pixel 10 Pro","u":"/collections/google-pixel-10-pro-back-cover"},
{"l":"Pixel 10A","u":"/collections/google-pixel-10a-back-cover"},
{"l":"Pixel 10","u":"/collections/google-pixel-10-back-cover"},
{"l":"Pixel 9 Pro XL","u":"/collections/google-pixel-9-pro-xl-back-cover"},
{"l":"Pixel 9 Pro","u":"/collections/google-pixel-9-pro-back-cover"},
{"l":"Pixel 9A","u":"/collections/google-pixel-9a-back-cover"},
{"l":"Pixel 9","u":"/collections/google-pixel-9-back-cover"},
{"l":"Pixel 8 Pro","u":"/collections/google-pixel-8-pro-back-cover"},
{"l":"Pixel 8A","u":"/collections/google-pixel-8a-back-cover"},
{"l":"Pixel 8","u":"/collections/google-pixel-8-back-cover"},
{"l":"Pixel 7 Pro","u":"/collections/google-pixel-7-pro-back-cover"},
{"l":"Pixel 7A","u":"/collections/google-pixel-7a-back-cover"},
{"l":"Pixel 7","u":"/collections/google-pixel-7-back-cover"},
{"l":"Pixel 6A","u":"/collections/google-pixel-6a-back-cover"},
// -- Not in OptionsExport CSV (kept, disabled) --
{"l":"Pixel 6","u":"/collections/google-pixel-6-back-cover"},
{"l":"Pixel 6 Pro","u":"/collections/google-pixel-6-pro-back-cover"},
],

"Motorola": [
{"l":"Edge 70 Fusion","u":"/collections/motorola-edge-70-fusion-back-cover"},
{"l":"Edge 60 Fusion","u":"/collections/motorola-edge-60-fusion-back-cover"},
{"l":"Edge 60 Pro","u":"/collections/motorola-edge-60-pro-back-cover"},
{"l":"Edge 60","u":"/collections/motorola-edge-60-back-cover"},
{"l":"Edge 50 Ultra","u":"/collections/motorola-edge-50-ultra-back-cover"},
{"l":"Edge 50 Neo","u":"/collections/motorola-edge-50-neo-back-cover"},
{"l":"Edge 50 Fusion","u":"/collections/motorola-edge-50-fusion-back-cover"},
{"l":"Edge 50 Pro","u":"/collections/motorola-edge-50-pro-back-cover"},
{"l":"Edge 50","u":"/collections/motorola-edge-50-back-cover"},
{"l":"Edge 40 Neo","u":"/collections/motorola-edge-40-neo-back-cover"},
{"l":"Edge 40","u":"/collections/motorola-edge-40-back-cover"},
{"l":"Edge 30 Ultra","u":"/collections/motorola-edge-30-ultra-back-cover"},
{"l":"Edge 30 Pro","u":"/collections/motorola-edge-30-pro-back-cover"},
{"l":"Edge 30","u":"/collections/motorola-edge-30-back-cover"},
{"l":"Moto G85","u":"/collections/motorola-moto-g85-back-cover"},
{"l":"Moto G84","u":"/collections/motorola-moto-g84-back-cover"},
{"l":"Moto G75","u":"/collections/motorola-moto-g75-back-cover"},
{"l":"Moto G67 Power","u":"/collections/motorola-moto-g67-power-back-cover"},
{"l":"Moto G64","u":"/collections/motorola-moto-g64-back-cover"},
{"l":"Moto G57 Power","u":"/collections/motorola-moto-g57-power-back-cover"},
{"l":"Moto G55","u":"/collections/motorola-moto-g55-back-cover"},
{"l":"Moto G54","u":"/collections/motorola-moto-g54-back-cover"},
{"l":"Moto G45","u":"/collections/motorola-moto-g45-back-cover"},
{"l":"Moto G35","u":"/collections/motorola-moto-g35-back-cover"},
// -- Not in OptionsExport CSV (kept, disabled) --
// {"l":"Edge 30 Fusion","u":"/collections/motorola-edge-30-fusion-back-cover"},
// {"l":"Edge 60 Stylus","u":"/collections/motorola-edge-60-stylus-back-cover"},
// {"l":"Moto E40","u":"/collections/motorola-moto-e40-back-cover"},
// {"l":"Moto G04","u":"/collections/motorola-moto-g04-back-cover"},
// {"l":"Moto G04S","u":"/collections/motorola-moto-g04s-back-cover"},
// {"l":"Moto G24","u":"/collections/motorola-moto-g24-back-cover"},
// {"l":"Moto G24 Power","u":"/collections/motorola-moto-g24-power-back-cover"},
// {"l":"Moto G31","u":"/collections/motorola-moto-g31-back-cover"},
// {"l":"Moto G32","u":"/collections/motorola-moto-g32-back-cover"},
// {"l":"Moto G34","u":"/collections/motorola-moto-g34-back-cover"},
// {"l":"Moto G40 Fusion","u":"/collections/motorola-moto-g40-fusion-back-cover"},
// {"l":"Moto G52","u":"/collections/motorola-moto-g52-back-cover"},
// {"l":"Moto G62","u":"/collections/motorola-moto-g62-back-cover"},
// {"l":"Moto G82","u":"/collections/motorola-moto-g82-back-cover"},
],

"Nothing": [
{"l":"Phone 4A Pro","u":"/collections/nothing-phone-4a-pro-back-cover"},
{"l":"Phone 4A","u":"/collections/nothing-phone-4a-back-cover"},
{"l":"Phone 3A Pro","u":"/collections/nothing-phone-3a-pro-back-cover"},
{"l":"Phone 3A","u":"/collections/nothing-phone-3a-back-cover"},
{"l":"Phone 2A Plus","u":"/collections/nothing-phone-2a-plus-back-cover"},
{"l":"Phone 2A","u":"/collections/nothing-phone-2a-back-cover"},
{"l":"Phone 2","u":"/collections/nothing-phone-2-back-cover"},
{"l":"Phone 1","u":"/collections/nothing-phone-1-back-cover"},
{"l":"CMF Phone 1","u":"/collections/nothing-cmf-phone-1-back-cover"},
],

"Oppo": [
{"l":"Reno 15F","u":"/collections/oppo-reno-15f-back-cover"},
{"l":"Reno 15C","u":"/collections/oppo-reno-15c-back-cover"},
{"l":"Reno 15","u":"/collections/oppo-reno-15-back-cover"},
{"l":"Reno 14 Pro","u":"/collections/oppo-reno-14-pro-back-cover"},
{"l":"Reno 14","u":"/collections/oppo-reno-14-back-cover"},
{"l":"Reno 13 Pro","u":"/collections/oppo-reno-13-pro-back-cover"},
{"l":"Reno 13","u":"/collections/oppo-reno-13-back-cover"},
{"l":"Reno 12 Pro","u":"/collections/oppo-reno-12-pro-back-cover"},
{"l":"Reno 12","u":"/collections/oppo-reno-12-back-cover"},
{"l":"Reno 11 Pro","u":"/collections/oppo-reno-11-pro-back-cover"},
{"l":"Reno 11F","u":"/collections/oppo-reno-11f-back-cover"},
{"l":"Reno 11","u":"/collections/oppo-reno-11-back-cover"},
{"l":"Reno 10 Pro Plus","u":"/collections/oppo-reno-10-pro-plus-back-cover"},
{"l":"Reno 10 Pro","u":"/collections/oppo-reno-10-pro-back-cover"},
{"l":"Reno 10","u":"/collections/oppo-reno-10-back-cover"},
{"l":"Reno 9 Pro Plus","u":"/collections/oppo-reno-9-pro-plus-back-cover"},
{"l":"Reno 9 Pro","u":"/collections/oppo-reno-9-pro-back-cover"},
{"l":"Reno 9","u":"/collections/oppo-reno-9-back-cover"},
{"l":"Reno 8Z","u":"/collections/oppo-reno-8z-back-cover"},
{"l":"Reno 8 Lite","u":"/collections/oppo-reno-8-lite-back-cover"},
{"l":"Reno 8 Pro","u":"/collections/oppo-reno-8-pro-back-cover"},
{"l":"Reno 8T 5G","u":"/collections/oppo-reno-8t-5g-back-cover"},
{"l":"Reno 8 5G","u":"/collections/oppo-reno-8-5g-back-cover"},
{"l":"Reno 7Z","u":"/collections/oppo-reno-7z-back-cover"},
{"l":"Reno 7 Lite","u":"/collections/oppo-reno-7-lite-back-cover"},
{"l":"Reno 7 Pro","u":"/collections/oppo-reno-7-pro-back-cover"},
{"l":"Reno 7 5G","u":"/collections/oppo-reno-7-5g-back-cover"},
{"l":"Reno 7 4G","u":"/collections/oppo-reno-7-4g-back-cover"},
{"l":"Reno 6 Pro","u":"/collections/oppo-reno-6-pro-back-cover"},
{"l":"Reno 6 5G","u":"/collections/oppo-reno-6-5g-back-cover"},
{"l":"Reno 6 4G","u":"/collections/oppo-reno-6-4g-back-cover"},
{"l":"Reno 2Z","u":"/collections/oppo-reno-2z-back-cover"},
{"l":"Reno 2F","u":"/collections/oppo-reno-2f-back-cover"},
{"l":"K13","u":"/collections/oppo-k13-back-cover"},
{"l":"K10 5G","u":"/collections/oppo-k10-5g-back-cover"},
{"l":"F31 Pro Plus","u":"/collections/oppo-f31-pro-plus-back-cover"},
{"l":"F31 Pro","u":"/collections/oppo-f31-pro-back-cover"},
{"l":"F31","u":"/collections/oppo-f31-back-cover"},
{"l":"F29 Pro","u":"/collections/oppo-f29-pro-back-cover"},
{"l":"F29","u":"/collections/oppo-f29-back-cover"},
{"l":"F27 Pro Plus","u":"/collections/oppo-f27-pro-plus-back-cover"},
{"l":"F27 Pro","u":"/collections/oppo-f27-pro-back-cover"},
{"l":"F27","u":"/collections/oppo-f27-back-cover"},
{"l":"F25 Pro","u":"/collections/oppo-f25-pro-back-cover"},
{"l":"F23","u":"/collections/oppo-f23-back-cover"},
{"l":"F21S Pro 5G","u":"/collections/oppo-f21s-pro-5g-back-cover"},
{"l":"F21 Pro 5G","u":"/collections/oppo-f21-pro-5g-back-cover"},
{"l":"F21S Pro 4G","u":"/collections/oppo-f21s-pro-4g-back-cover"},
{"l":"F21 Pro 4G","u":"/collections/oppo-f21-pro-4g-back-cover"},
{"l":"F19 Pro Plus","u":"/collections/oppo-f19-pro-plus-back-cover"},
{"l":"F19 Pro","u":"/collections/oppo-f19-pro-back-cover"},
{"l":"F19","u":"/collections/oppo-f19-back-cover"},
{"l":"F11 Pro","u":"/collections/oppo-f11-pro-back-cover"},
{"l":"A96","u":"/collections/oppo-a96-back-cover"},
{"l":"A95 5G","u":"/collections/oppo-a95-5g-back-cover"},
{"l":"A94 4G","u":"/collections/oppo-a94-4g-back-cover"},
{"l":"A79","u":"/collections/oppo-a79-back-cover"},
{"l":"A78 5G","u":"/collections/oppo-a78-5g-back-cover"},
{"l":"A78 4G","u":"/collections/oppo-a78-4g-back-cover"},
{"l":"A77 5G","u":"/collections/oppo-a77-5g-back-cover"},
{"l":"A77 4G","u":"/collections/oppo-a77-4g-back-cover"},
{"l":"A76","u":"/collections/oppo-a76-back-cover"},
{"l":"A74 5G","u":"/collections/oppo-a74-5g-back-cover"},
{"l":"A74 4G","u":"/collections/oppo-a74-4g-back-cover"},
{"l":"A59","u":"/collections/oppo-a59-back-cover"},
{"l":"A58X","u":"/collections/oppo-a58x-back-cover"},
{"l":"A58","u":"/collections/oppo-a58-back-cover"},
{"l":"A57 5G","u":"/collections/oppo-a57-5g-back-cover"},
{"l":"A57 4G","u":"/collections/oppo-a57-4g-back-cover"},
{"l":"A55 5G","u":"/collections/oppo-a55-5g-back-cover"},
{"l":"A53S 4G","u":"/collections/oppo-a53s-4g-back-cover"},
{"l":"A53 4G","u":"/collections/oppo-a53-4g-back-cover"},
{"l":"A38","u":"/collections/oppo-a38-back-cover"},
{"l":"A36","u":"/collections/oppo-a36-back-cover"},
{"l":"A18","u":"/collections/oppo-a18-back-cover"},
{"l":"A17K","u":"/collections/oppo-a17k-back-cover"},
{"l":"A17","u":"/collections/oppo-a17-back-cover"},
{"l":"A16","u":"/collections/oppo-a16-back-cover"},
{"l":"A15","u":"/collections/oppo-a15-back-cover"},
{"l":"A6X","u":"/collections/oppo-a6x-back-cover"},
{"l":"A6","u":"/collections/oppo-a6-back-cover"},
{"l":"A5X","u":"/collections/oppo-a5x-back-cover"},
{"l":"A5 Pro","u":"/collections/oppo-a5-pro-back-cover"},
{"l":"A5 2025","u":"/collections/oppo-a5-2025-back-cover"},
{"l":"A5 2020","u":"/collections/oppo-a5-2020-back-cover"},
{"l":"A3X 5G","u":"/collections/oppo-a3x-5g-back-cover"},
{"l":"A3 Pro","u":"/collections/oppo-a3-pro-back-cover"},
{"l":"A1 Pro","u":"/collections/oppo-a1-pro-back-cover"},
// -- Not in OptionsExport CSV (kept, disabled) --
// {"l":"A55 4G","u":"/collections/oppo-a55-4g-back-cover"},
// {"l":"A77S","u":"/collections/oppo-a77s-back-cover"},
// {"l":"A98","u":"/collections/oppo-a98-back-cover"},
// {"l":"K12","u":"/collections/oppo-k12-back-cover"},
// {"l":"K12X","u":"/collections/oppo-k12x-back-cover"},
// {"l":"Reno 8 4G","u":"/collections/oppo-reno-8-4g-back-cover"},
],

"Realme": [
{"l":"Narzo 70 Pro","u":"/collections/realme-narzo-70-pro-back-cover"},
{"l":"Narzo 70X","u":"/collections/realme-narzo-70x-back-cover"},
{"l":"Narzo 70","u":"/collections/realme-narzo-70-back-cover"},
{"l":"Narzo N63","u":"/collections/realme-narzo-n63-back-cover"},
{"l":"Narzo 60 Pro","u":"/collections/realme-narzo-60-pro-back-cover"},
{"l":"Narzo 60","u":"/collections/realme-narzo-60-back-cover"},
{"l":"Narzo N55","u":"/collections/realme-narzo-n55-back-cover"},
{"l":"Narzo N53","u":"/collections/realme-narzo-n53-back-cover"},
{"l":"Narzo 50i","u":"/collections/realme-narzo-50i-back-cover"},
{"l":"Narzo 30 5G","u":"/collections/realme-narzo-30-5g-back-cover"},
{"l":"Narzo 20 Pro","u":"/collections/realme-narzo-20-pro-back-cover"},
{"l":"Neo 7 SE","u":"/collections/realme-neo-7-se-back-cover"},
{"l":"Neo 7X","u":"/collections/realme-neo-7x-back-cover"},
{"l":"GT Neo 6 SE","u":"/collections/realme-gt-neo-6-se-back-cover"},
{"l":"GT Neo 6","u":"/collections/realme-gt-neo-6-back-cover"},
{"l":"GT Neo 3T","u":"/collections/realme-gt-neo-3t-back-cover"},
{"l":"GT Neo 3","u":"/collections/realme-gt-neo-3-back-cover"},
{"l":"GT Neo 2T","u":"/collections/realme-gt-neo-2t-back-cover"},
{"l":"GT Neo 2","u":"/collections/realme-gt-neo-2-back-cover"},
{"l":"GT Master","u":"/collections/realme-gt-master-back-cover"},
{"l":"GT 7 Pro","u":"/collections/realme-gt-7-pro-back-cover"},
{"l":"GT 7","u":"/collections/realme-gt-7-back-cover"},
{"l":"GT 6T","u":"/collections/realme-gt-6t-back-cover"},
{"l":"GT 6","u":"/collections/realme-gt-6-back-cover"},
{"l":"GT 2 Pro","u":"/collections/realme-gt-2-pro-back-cover"},
{"l":"GT 2","u":"/collections/realme-gt-2-back-cover"},
{"l":"GT","u":"/collections/realme-gt-back-cover"},
{"l":"X50 Pro","u":"/collections/realme-x50-pro-back-cover"},
{"l":"X7 Pro","u":"/collections/realme-x7-pro-back-cover"},
{"l":"X7 Max","u":"/collections/realme-x7-max-back-cover"},
{"l":"X7","u":"/collections/realme-x7-back-cover"},
{"l":"X3","u":"/collections/realme-x3-back-cover"},
{"l":"XT","u":"/collections/realme-xt-back-cover"},
{"l":"V13","u":"/collections/realme-v13-back-cover"},
{"l":"Q3 Pro","u":"/collections/realme-q3-pro-back-cover"},
//{"l":"P4X","u":"/collections/realme-p4x-back-cover"},
{"l":"P4 Power","u":"/collections/realme-p4-power-back-cover"},
{"l":"P4 Pro","u":"/collections/realme-p4-pro-back-cover"},
{"l":"P4","u":"/collections/realme-p4-pro-back-cover"},
{"l":"P3 Ultra","u":"/collections/realme-p3-ultra-back-cover"},
{"l":"P3","u":"/collections/realme-p3-back-cover"},
{"l":"P2 Pro","u":"/collections/realme-p2-pro-back-cover"},
{"l":"P1 Pro","u":"/collections/realme-p1-pro-back-cover"},
{"l":"P1","u":"/collections/realme-p1-back-cover"},
{"l":"C85 5G","u":"/collections/realme-c85-5g-back-cover"},
{"l":"C67 5G","u":"/collections/realme-c67-5g-back-cover"},
{"l":"C65 5G","u":"/collections/realme-c65-5g-back-cover"},
{"l":"C63 5G","u":"/collections/realme-c63-5g-back-cover"},
{"l":"C55","u":"/collections/realme-c55-back-cover"},
{"l":"C53","u":"/collections/realme-c53-back-cover"},
{"l":"C35","u":"/collections/realme-c35-back-cover"},
{"l":"C31","u":"/collections/realme-c31-back-cover"},
{"l":"C25","u":"/collections/realme-c25-back-cover"},
{"l":"C21Y","u":"/collections/realme-c21y-back-cover"},
{"l":"15 Pro","u":"/collections/realme-15-pro-back-cover"},
{"l":"15","u":"/collections/realme-15-back-cover"},
{"l":"15T","u":"/collections/realme-15t-back-cover"},
{"l":"14 Pro Plus","u":"/collections/realme-14-pro-plus-back-cover"},
{"l":"14 Pro","u":"/collections/realme-14-pro-back-cover"},
{"l":"14X","u":"/collections/realme-14x-back-cover"},
{"l":"14T","u":"/collections/realme-14t-back-cover"},
{"l":"14","u":"/collections/realme-14-back-cover"},
{"l":"13 Pro Plus","u":"/collections/realme-13-pro-plus-back-cover"},
{"l":"13 Pro","u":"/collections/realme-13-pro-back-cover"},
{"l":"12 Pro Plus","u":"/collections/realme-12-pro-plus-back-cover"},
{"l":"12 Pro","u":"/collections/realme-12-pro-back-cover"},
{"l":"12 Plus","u":"/collections/realme-12-plus-back-cover"},
{"l":"12X","u":"/collections/realme-12x-back-cover"},
{"l":"12 5G","u":"/collections/realme-12-5g-back-cover"},
{"l":"12 4G","u":"/collections/realme-12-4g-back-cover"},
{"l":"11 Pro Plus","u":"/collections/realme-11-pro-plus-back-cover"},
{"l":"11 Pro","u":"/collections/realme-11-pro-back-cover"},
{"l":"11X","u":"/collections/realme-11x-back-cover"},
{"l":"11 5G","u":"/collections/realme-11-5g-back-cover"},
{"l":"10 Pro Plus","u":"/collections/realme-10-pro-plus-back-cover"},
{"l":"10 Pro","u":"/collections/realme-10-pro-back-cover"},
{"l":"9 Pro Plus","u":"/collections/realme-9-pro-plus-back-cover"},
{"l":"9 Pro","u":"/collections/realme-9-pro-back-cover"},
//{"l":"9 5G","u":"/collections/realme-9-5g-back-cover"},
{"l":"9 4G","u":"/collections/realme-9-4g-back-cover"},
{"l":"8 Pro","u":"/collections/realme-8-pro-back-cover"},
{"l":"8i","u":"/collections/realme-8i-back-cover"},
{"l":"8 5G","u":"/collections/realme-8-5g-back-cover"},
{"l":"8 4G","u":"/collections/realme-8-4g-back-cover"},
{"l":"7 Pro","u":"/collections/realme-7-pro-back-cover"},
{"l":"7 4G","u":"/collections/realme-7-4g-back-cover"},
{"l":"5 Pro","u":"/collections/realme-5-pro-back-cover"},
// -- Not in OptionsExport CSV (kept, disabled) --
// {"l":"8S","u":"/collections/realme-8s-back-cover"},
// {"l":"9 Speed","u":"/collections/realme-9-speed-back-cover"},
// {"l":"9i 4G","u":"/collections/realme-9i-4g-back-cover"},
// {"l":"9i 5G","u":"/collections/realme-9i-5g-back-cover"},
// {"l":"10 4G","u":"/collections/realme-10-4g-back-cover"},
// {"l":"10 5G","u":"/collections/realme-10-5g-back-cover"},
// {"l":"11 4G","u":"/collections/realme-11-4g-back-cover"},
// {"l":"13 4G","u":"/collections/realme-13-4g-back-cover"},
// {"l":"13 5G","u":"/collections/realme-13-5g-back-cover"},
// {"l":"13 Plus","u":"/collections/realme-13-plus-back-cover"},
// {"l":"C11 2021","u":"/collections/realme-c11-2021-back-cover"},
// {"l":"C15","u":"/collections/realme-c15-back-cover"},
// {"l":"C17","u":"/collections/realme-c17-back-cover"},
// {"l":"C20","u":"/collections/realme-c20-back-cover"},
// {"l":"C21","u":"/collections/realme-c21-back-cover"},
// {"l":"C25Y","u":"/collections/realme-c25y-back-cover"},
// {"l":"C30","u":"/collections/realme-c30-back-cover"},
// {"l":"C30S","u":"/collections/realme-c30s-back-cover"},
// {"l":"C33","u":"/collections/realme-c33-back-cover"},
// {"l":"C51","u":"/collections/realme-c51-back-cover"},
// {"l":"C61","u":"/collections/realme-c61-back-cover"},
// {"l":"C63 4G","u":"/collections/realme-c63-4g-back-cover"},
// {"l":"GT Neo Flash","u":"/collections/realme-gt-neo-flash-back-cover"},
// {"l":"Narzo 30A","u":"/collections/realme-narzo-30a-back-cover"},
// {"l":"Narzo 50 5G","u":"/collections/realme-narzo-50-5g-back-cover"},
// {"l":"Narzo 50 Pro","u":"/collections/realme-narzo-50-pro-back-cover"},
// {"l":"Narzo 50A","u":"/collections/realme-narzo-50a-back-cover"},
// {"l":"Narzo 50i Prime","u":"/collections/realme-narzo-50i-prime-back-cover"},
// {"l":"Narzo 60X","u":"/collections/realme-narzo-60x-back-cover"},
// {"l":"Narzo 80 Lite 5G","u":"/collections/realme-narzo-80-lite-5g-back-cover"},
// {"l":"P1 Speed","u":"/collections/realme-p1-speed-back-cover"},
// {"l":"P3 Pro","u":"/collections/realme-p3-pro-back-cover"},
// {"l":"Q3","u":"/collections/realme-q3-back-cover"},
// {"l":"Q3i","u":"/collections/realme-q3i-back-cover"},
// {"l":"Q5","u":"/collections/realme-q5-back-cover"},
// {"l":"Q5 Pro","u":"/collections/realme-q5-pro-back-cover"},
// {"l":"V23","u":"/collections/realme-v23-back-cover"},
// {"l":"V25","u":"/collections/realme-v25-back-cover"},
// {"l":"V60","u":"/collections/realme-v60-back-cover"},
],

"Vivo": [
{"l":"Y400 Pro","u":"/collections/vivo-y400-pro-back-cover"},
{"l":"Y400","u":"/collections/vivo-y400-back-cover"},
{"l":"Y300","u":"/collections/vivo-y300-back-cover"},
{"l":"Y200E","u":"/collections/vivo-y200e-back-cover"},
{"l":"Y200 5G","u":"/collections/vivo-y200-5g-back-cover"},
{"l":"Y100A","u":"/collections/vivo-y100a-back-cover"},
{"l":"Y100 5G","u":"/collections/vivo-y100-5g-back-cover"},
{"l":"Y75S","u":"/collections/vivo-y75s-back-cover"},
{"l":"Y75 5G","u":"/collections/vivo-y75-5g-back-cover"},
{"l":"Y75 4G","u":"/collections/vivo-y75-4g-back-cover"},
{"l":"Y73","u":"/collections/vivo-y73-back-cover"},
{"l":"Y58","u":"/collections/vivo-y58-back-cover"},
{"l":"Y56","u":"/collections/vivo-y56-back-cover"},
{"l":"Y51A","u":"/collections/vivo-y51a-back-cover"},
{"l":"Y51 Pro","u":"/collections/vivo-y51-pro-back-cover"},
{"l":"Y51 2020","u":"/collections/vivo-y51-2020-back-cover"},
{"l":"Y39","u":"/collections/vivo-y39-back-cover"},
{"l":"Y38","u":"/collections/vivo-y38-back-cover"},
{"l":"Y36","u":"/collections/vivo-y36-back-cover"},
{"l":"Y35 4G","u":"/collections/vivo-y35-4g-back-cover"},
{"l":"Y33T","u":"/collections/vivo-y33t-back-cover"},
{"l":"Y33S 4G","u":"/collections/vivo-y33s-4g-back-cover"},
{"l":"Y31 5G","u":"/collections/vivo-y31-5g-back-cover"},
{"l":"Y31 2021","u":"/collections/vivo-y31-2021-back-cover"},
{"l":"Y30 5G","u":"/collections/vivo-y30-5g-back-cover"},
{"l":"Y29 5G","u":"/collections/vivo-y29-5g-back-cover"},
{"l":"Y29 4G","u":"/collections/vivo-y29-4g-back-cover"},
{"l":"Y28S","u":"/collections/vivo-y28s-back-cover"},
{"l":"Y28E","u":"/collections/vivo-y28e-back-cover"},
{"l":"Y28 5G","u":"/collections/vivo-y28-5g-back-cover"},
{"l":"Y27S","u":"/collections/vivo-y27s-back-cover"},
{"l":"Y27 5G","u":"/collections/vivo-y27-5g-back-cover"},
{"l":"Y27 4G","u":"/collections/vivo-y27-4g-back-cover"},
{"l":"Y22S","u":"/collections/vivo-y22s-back-cover"},
{"l":"Y22","u":"/collections/vivo-y22-back-cover"},
{"l":"Y21T","u":"/collections/vivo-y21t-back-cover"},
{"l":"Y21S","u":"/collections/vivo-y21s-back-cover"},
{"l":"Y21 5G","u":"/collections/vivo-y21-back-cover"},
{"l":"Y21 4G","u":"/collections/vivo-y21-back-cover"},
{"l":"Y20","u":"/collections/vivo-y20-back-cover"},
{"l":"Y19S 5G","u":"/collections/vivo-y19s-5g-back-cover"},
{"l":"Y19 5G","u":"/collections/vivo-y19-5g-back-cover"},
{"l":"Y18E","u":"/collections/vivo-y18e-back-cover"},
{"l":"Y18","u":"/collections/vivo-y18-back-cover"},
{"l":"Y17S","u":"/collections/vivo-y17s-back-cover"},
{"l":"Y16","u":"/collections/vivo-y16-back-cover"},
{"l":"Y12S","u":"/collections/vivo-y12s-back-cover"},
{"l":"Y11 5G","u":"/collections/vivo-y11-5g-back-cover"},
{"l":"Y05","u":"/collections/vivo-y05-back-cover"},
{"l":"Y04","u":"/collections/vivo-y04-back-cover"},
{"l":"Y03","u":"/collections/vivo-y03-back-cover"},
{"l":"Y02T","u":"/collections/vivo-y02t-back-cover"},
{"l":"Y02","u":"/collections/vivo-y02-back-cover"},
{"l":"X300 Pro","u":"/collections/vivo-x300-pro-back-cover"},
{"l":"X300","u":"/collections/vivo-x300-back-cover"},
{"l":"X200 FE","u":"/collections/vivo-x200-fe-back-cover"},
{"l":"X200 Pro","u":"/collections/vivo-x200-pro-back-cover"},
{"l":"X200","u":"/collections/vivo-x200-back-cover"},
{"l":"X100 Pro","u":"/collections/vivo-x100-pro-back-cover"},
{"l":"X100","u":"/collections/vivo-x100-back-cover"},
{"l":"X90 Pro","u":"/collections/vivo-x90-pro-back-cover"},
{"l":"X90","u":"/collections/vivo-x90-back-cover"},
{"l":"X80 Pro","u":"/collections/vivo-x80-pro-back-cover"},
{"l":"X80","u":"/collections/vivo-x80-back-cover"},
{"l":"X70 Pro Plus","u":"/collections/vivo-x70-pro-plus-back-cover"},
{"l":"X70 Pro","u":"/collections/vivo-x70-pro-back-cover"},
{"l":"X70","u":"/collections/vivo-x70-back-cover"},
{"l":"X60 Pro Plus","u":"/collections/vivo-x60-pro-plus-back-cover"},
{"l":"X60 Pro","u":"/collections/vivo-x60-pro-back-cover"},
{"l":"X60","u":"/collections/vivo-x60-back-cover"},
{"l":"V70 Elite","u":"/collections/vivo-v70-elite-back-cover"},
{"l":"V70 FE","u":"/collections/vivo-v70-fe-back-cover"},
{"l":"V70","u":"/collections/vivo-v70-back-cover"},
{"l":"V60","u":"/collections/vivo-v60-back-cover"},
{"l":"V50E","u":"/collections/vivo-v50e-back-cover"},
{"l":"V50","u":"/collections/vivo-v50-back-cover"},
{"l":"V40 Lite","u":"/collections/vivo-v40-lite-back-cover"},
{"l":"V40 Pro","u":"/collections/vivo-v40-pro-back-cover"},
{"l":"V40E","u":"/collections/vivo-v40e-back-cover"},
{"l":"V40","u":"/collections/vivo-v40-back-cover"},
{"l":"V30 Pro","u":"/collections/vivo-v30-pro-back-cover"},
{"l":"V30E","u":"/collections/vivo-v30e-back-cover"},
{"l":"V30","u":"/collections/vivo-v30-back-cover"},
{"l":"V29 Pro","u":"/collections/vivo-v29-pro-back-cover"},
{"l":"V29E","u":"/collections/vivo-v29e-back-cover"},
{"l":"V29","u":"/collections/vivo-v29-back-cover"},
{"l":"V27 Pro","u":"/collections/vivo-v27-pro-back-cover"},
{"l":"V27","u":"/collections/vivo-v27-back-cover"},
{"l":"V25 Pro","u":"/collections/vivo-v25-pro-back-cover"},
{"l":"V25E","u":"/collections/vivo-v25e-back-cover"},
{"l":"V25","u":"/collections/vivo-v25-back-cover"},
{"l":"V23 Pro","u":"/collections/vivo-v23-pro-back-cover"},
{"l":"V23E","u":"/collections/vivo-v23e-back-cover"},
{"l":"V23","u":"/collections/vivo-v23-back-cover"},
{"l":"V21S","u":"/collections/vivo-v21s-back-cover"},
{"l":"V21E 5G","u":"/collections/vivo-v21e-5g-back-cover"},
{"l":"V21E 4G","u":"/collections/vivo-v21e-4g-back-cover"},
{"l":"V21","u":"/collections/vivo-v21-back-cover"},
{"l":"V20 SE","u":"/collections/vivo-v20-se-back-cover"},
{"l":"V20 Pro","u":"/collections/vivo-v20-pro-back-cover"},
{"l":"V20","u":"/collections/vivo-v20-back-cover"},
{"l":"V19","u":"/collections/vivo-v19-back-cover"},
{"l":"V17","u":"/collections/vivo-v17-back-cover"},
{"l":"T5X","u":"/collections/vivo-t5x-back-cover"},
{"l":"T4X","u":"/collections/vivo-t4x-back-cover"},
{"l":"T4 Ultra","u":"/collections/vivo-t4-ultra-back-cover"},
{"l":"T4 Lite","u":"/collections/vivo-t4-lite-back-cover"},
{"l":"T4 Pro","u":"/collections/vivo-t4-pro-back-cover"},
{"l":"T4","u":"/collections/vivo-t4-back-cover"},
{"l":"T3X","u":"/collections/vivo-t3x-back-cover"},
{"l":"T3 Lite","u":"/collections/vivo-t3-lite-back-cover"},
{"l":"T3 Pro","u":"/collections/vivo-t3-pro-back-cover"},
{"l":"T3","u":"/collections/vivo-t3-back-cover"},
{"l":"T2X","u":"/collections/vivo-t2x-back-cover"},
{"l":"T2 Pro","u":"/collections/vivo-t2-pro-back-cover"},
{"l":"T2 5G","u":"/collections/vivo-t2-5g-back-cover"},
{"l":"T1X 4G","u":"/collections/vivo-t1x-4g-back-cover"},
{"l":"T1 Pro","u":"/collections/vivo-t1-pro-back-cover"},
{"l":"T1 5G","u":"/collections/vivo-t1-5g-back-cover"},
// -- Not in OptionsExport CSV (kept, disabled) --
// {"l":"V27E","u":"/collections/vivo-v27e-back-cover"},
// {"l":"Y01","u":"/collections/vivo-y01-back-cover"},
// {"l":"Y02S","u":"/collections/vivo-y02s-back-cover"},
// {"l":"Y15S","u":"/collections/vivo-y15s-back-cover"},
// {"l":"Y33E","u":"/collections/vivo-y33e-back-cover"},
// {"l":"Y33S 5G","u":"/collections/vivo-y33s-5g-back-cover"},
// {"l":"Y35 Plus","u":"/collections/vivo-y35-plus-back-cover"},
// {"l":"Y52T","u":"/collections/vivo-y52t-back-cover"},
// {"l":"Y55 5G","u":"/collections/vivo-y55-5g-back-cover"},
// {"l":"Y70","u":"/collections/vivo-y70-back-cover"},
// {"l":"Y71T","u":"/collections/vivo-y71t-back-cover"},
// {"l":"Y77","u":"/collections/vivo-y77-back-cover"},
// {"l":"Y78","u":"/collections/vivo-y78-back-cover"},
// {"l":"Y200","u":"/collections/vivo-y200-back-cover"},
// {"l":"Y200 Pro","u":"/collections/vivo-y200-pro-back-cover"},
// {"l":"Y200T","u":"/collections/vivo-y200t-back-cover"},
// {"l":"Y300 Plus","u":"/collections/vivo-y300-plus-back-cover"},
// {"l":"X60T","u":"/collections/vivo-x60t-back-cover"},
// {"l":"X80 Lite","u":"/collections/vivo-x80-lite-back-cover"},
// {"l":"X200","u":"/collections/vivo-x200-back-cover"},
// {"l":"X200 Pro","u":"/collections/vivo-x200-pro-back-cover"},
],

"iQOO": [
{"l":"iQOO Neo 10R","u":"/collections/vivo-iqoo-neo-10r-back-cover"},
{"l":"iQOO Neo 10","u":"/collections/vivo-iqoo-neo-10-back-cover"},
{"l":"iQOO Neo 9 Pro","u":"/collections/vivo-iqoo-neo-9-pro-back-cover"},
{"l":"iQOO Neo 9","u":"/collections/vivo-iqoo-neo-9-back-cover"},
{"l":"iQOO Neo 7 Racing","u":"/collections/vivo-iqoo-neo-7-racing-back-cover"},
{"l":"iQOO Neo 7 SE","u":"/collections/vivo-iqoo-neo-7-se-back-cover"},
{"l":"iQOO Neo 7 Pro","u":"/collections/vivo-iqoo-neo-7-pro-back-cover"},
{"l":"iQOO Neo 7","u":"/collections/vivo-iqoo-neo-7-back-cover"},
{"l":"iQOO Neo 6 SE","u":"/collections/vivo-iqoo-neo-6-se-back-cover"},
{"l":"iQOO Neo 6","u":"/collections/vivo-iqoo-neo-6-back-cover"},
{"l":"iQOO Neo 5S","u":"/collections/vivo-iqoo-neo-5s-back-cover"},
{"l":"iQOO Neo 5","u":"/collections/vivo-iqoo-neo-5-back-cover"},
{"l":"iQOO Z10X","u":"/collections/vivo-iqoo-z10x-back-cover"},
{"l":"iQOO Z10 Turbo","u":"/collections/vivo-iqoo-z10-turbo-back-cover"},
{"l":"iQOO Z10 Lite","u":"/collections/vivo-iqoo-z10-lite-back-cover"},
{"l":"iQOO Z9X","u":"/collections/vivo-iqoo-z9x-back-cover"},
{"l":"iQOO Z9S Pro","u":"/collections/vivo-iqoo-z9s-pro-back-cover"},
{"l":"iQOO Z9S","u":"/collections/vivo-iqoo-z9s-back-cover"},
{"l":"iQOO Z9","u":"/collections/vivo-iqoo-z9-back-cover"},
{"l":"iQOO Z7 Pro","u":"/collections/vivo-iqoo-z7-pro-back-cover"},
{"l":"iQOO Z6 Pro","u":"/collections/vivo-iqoo-z6-pro-back-cover"},
{"l":"iQOO Z6 Lite","u":"/collections/vivo-iqoo-z6-lite-back-cover"},
{"l":"iQOO Z5","u":"/collections/vivo-iqoo-z5-back-cover"},
{"l":"iQOO Z3","u":"/collections/vivo-iqoo-z3-back-cover"},
{"l":"iQOO 15R","u":"/collections/vivo-iqoo-15r-back-cover"},
{"l":"iQOO 15","u":"/collections/vivo-iqoo-15-back-cover"},
{"l":"iQOO 13","u":"/collections/vivo-iqoo-13-back-cover"},
{"l":"iQOO 12 Pro","u":"/collections/vivo-iqoo-12-pro-back-cover"},
{"l":"iQOO 12","u":"/collections/vivo-iqoo-12-back-cover"},
{"l":"iQOO 9 SE","u":"/collections/vivo-iqoo-9-se-back-cover"},
{"l":"iQOO 9 Pro","u":"/collections/vivo-iqoo-9-pro-back-cover"},
{"l":"iQOO 9","u":"/collections/vivo-iqoo-9-back-cover"},
{"l":"iQOO 8","u":"/collections/vivo-iqoo-8-back-cover"},
{"l":"iQOO 7 Legend","u":"/collections/vivo-iqoo-7-legend-back-cover"},
{"l":"iQOO 7","u":"/collections/vivo-iqoo-7-back-cover"},
{"l":"iQOO 3","u":"/collections/vivo-iqoo-3-back-cover"},
// -- Not in OptionsExport CSV (kept, disabled) --
// {"l":"iQOO 9T","u":"/collections/vivo-iqoo-9t-back-cover"},
// {"l":"iQOO 10","u":"/collections/vivo-iqoo-10-back-cover"},
// {"l":"iQOO 11","u":"/collections/vivo-iqoo-11-back-cover"},
// {"l":"iQOO U5E","u":"/collections/vivo-iqoo-u5e-back-cover"},
// {"l":"iQOO Z6","u":"/collections/vivo-iqoo-z6-back-cover"},
// {"l":"iQOO Z7","u":"/collections/vivo-iqoo-z7-back-cover"},
// {"l":"iQOO Z7S","u":"/collections/vivo-iqoo-z7s-back-cover"},
// {"l":"iQOO Z9 Lite","u":"/collections/vivo-iqoo-z9-lite-back-cover"},
],

"Xiaomi": [
{"l":"14 Ultra","u":"/collections/xiaomi-14-ultra-back-cover"},
{"l":"14 Civi","u":"/collections/xiaomi-14-civi-back-cover"},
{"l":"14","u":"/collections/xiaomi-14-back-cover"},
{"l":"13 Ultra","u":"/collections/xiaomi-13-ultra-back-cover"},
{"l":"13 Pro","u":"/collections/xiaomi-13-pro-back-cover"},
{"l":"13","u":"/collections/xiaomi-13-back-cover"},
{"l":"12X","u":"/collections/xiaomi-12x-back-cover"},
{"l":"12 Lite","u":"/collections/xiaomi-12-lite-back-cover"},
{"l":"12S Pro","u":"/collections/xiaomi-12s-pro-back-cover"},
//{"l":"12 Pro","u":"/collections/xiaomi-12-pro-back-cover"},
{"l":"11 Lite NE 5G","u":"/collections/xiaomi-11-lite-ne-5g-back-cover"},
{"l":"11T Pro","u":"/collections/xiaomi-11t-pro-back-cover"},
{"l":"11i HyperCharge","u":"/collections/xiaomi-11i-hypercharge-back-cover"},
{"l":"11i","u":"/collections/xiaomi-11i-back-cover"},
{"l":"Mi 11X Pro","u":"/collections/xiaomi-mi-11x-pro-back-cover"},
{"l":"Mi 11X","u":"/collections/xiaomi-mi-11x-back-cover"},
{"l":"Mi 11 Lite","u":"/collections/xiaomi-mi-11-lite-back-cover"},
{"l":"Mi 11i","u":"/collections/xiaomi-mi-11i-back-cover"},
{"l":"Mi Note 10 Lite","u":"/collections/xiaomi-mi-note-10-lite-back-cover"},
// -- Not in OptionsExport CSV (kept, disabled) --
// {"l":"11T","u":"/collections/xiaomi-11t-back-cover"},
// {"l":"Mi 10T Lite","u":"/collections/xiaomi-mi-10t-lite-back-cover"},
// {"l":"Mi 10i","u":"/collections/xiaomi-mi-10i-back-cover"},
],

"Redmi": [
{"l":"Note 15 Pro Plus","u":"/collections/redmi-note-15-pro-plus-back-cover"},
{"l":"Note 15 Pro 5G","u":"/collections/redmi-note-15-pro-5g-back-cover"},
{"l":"Note 15","u":"/collections/redmi-note-15-back-cover"},
{"l":"Note 14 Pro Plus","u":"/collections/redmi-note-14-pro-plus-back-cover"},
{"l":"Note 14 Pro 5G","u":"/collections/redmi-note-14-pro-5g-back-cover"},
{"l":"Note 14 Pro 4G","u":"/collections/redmi-note-14-pro-4g-back-cover"},
{"l":"Note 14 4G","u":"/collections/redmi-note-14-4g-back-cover"},
{"l":"Note 13 Pro Plus","u":"/collections/redmi-note-13-pro-plus-back-cover"},
{"l":"Note 13 Pro 5G","u":"/collections/redmi-note-13-pro-5g-back-cover"},
{"l":"Note 13 5G","u":"/collections/redmi-note-13-5g-back-cover"},
{"l":"Note 12 Pro Speed","u":"/collections/redmi-note-12-pro-speed-back-cover"},
{"l":"Note 12 Pro Plus","u":"/collections/redmi-note-12-pro-plus-back-cover"},
{"l":"Note 12 Pro 5G","u":"/collections/redmi-note-12-pro-5g-back-cover"},
{"l":"Note 12R","u":"/collections/redmi-note-12r-back-cover"},
{"l":"Note 12 5G","u":"/collections/redmi-note-12-5g-back-cover"},
{"l":"Note 12 4G","u":"/collections/redmi-note-12-4g-back-cover"},
{"l":"Note 11T Pro Plus","u":"/collections/redmi-note-11t-pro-plus-back-cover"},
{"l":"Note 11T Pro","u":"/collections/redmi-note-11t-pro-back-cover"},
{"l":"Note 11T","u":"/collections/redmi-note-11t-back-cover"},
{"l":"Note 11 Pro Plus","u":"/collections/redmi-note-11-pro-plus-back-cover"},
{"l":"Note 11E Pro","u":"/collections/redmi-note-11e-pro-back-cover"},
{"l":"Note 11 SE","u":"/collections/redmi-note-11-se-back-cover"},
{"l":"Note 11S 5G","u":"/collections/redmi-note-11s-5g-back-cover"},
{"l":"Note 11S 4G","u":"/collections/redmi-note-11s-4g-back-cover"},
{"l":"Note 11","u":"/collections/redmi-note-11-back-cover"},
{"l":"Note 10 Pro Max","u":"/collections/redmi-note-10-pro-max-back-cover"},
{"l":"Note 10 Pro","u":"/collections/redmi-note-10-pro-back-cover"},
{"l":"Note 10 Lite","u":"/collections/redmi-note-10-lite-back-cover"},
{"l":"Note 10T","u":"/collections/redmi-note-10t-back-cover"},
{"l":"Note 10S","u":"/collections/redmi-note-10s-back-cover"},
{"l":"Note 10 5G","u":"/collections/redmi-note-10-5g-back-cover"},
{"l":"Note 10 4G","u":"/collections/redmi-note-10-4g-back-cover"},
{"l":"Note 9 Pro Max","u":"/collections/redmi-note-9-pro-max-back-cover"},
{"l":"Note 9 Pro 5G","u":"/collections/redmi-note-9-pro-5g-back-cover"},
{"l":"Note 9 Pro 4G","u":"/collections/redmi-note-9-pro-4g-back-cover"},
{"l":"Note 9S","u":"/collections/redmi-note-9s-back-cover"},
{"l":"Note 8 Pro","u":"/collections/redmi-note-8-pro-back-cover"},
{"l":"Note 7 Pro","u":"/collections/redmi-note-7-pro-back-cover"},
{"l":"Note 7","u":"/collections/redmi-note-7-back-cover"},
{"l":"K80 Pro","u":"/collections/redmi-k80-pro-back-cover"},
{"l":"K80","u":"/collections/redmi-k80-back-cover"},
{"l":"K50i","u":"/collections/redmi-k50i-back-cover"},
{"l":"K40","u":"/collections/redmi-k40-back-cover"},
{"l":"K20 Pro","u":"/collections/redmi-k20-pro-back-cover"},
{"l":"K20","u":"/collections/redmi-k20-back-cover"},
{"l":"A5","u":"/collections/redmi-a5-back-cover"},
{"l":"A3","u":"/collections/redmi-a3-back-cover"},
{"l":"A2 Plus","u":"/collections/redmi-a2-plus-back-cover"},
{"l":"A2","u":"/collections/redmi-a2-back-cover"},
{"l":"A1","u":"/collections/redmi-a1-back-cover"},
{"l":"15C 4G","u":"/collections/redmi-15c-4g-back-cover"},
{"l":"15 5G","u":"/collections/redmi-15-5g-back-cover"},
{"l":"15 4G","u":"/collections/redmi-15-4g-back-cover"},
{"l":"14C","u":"/collections/redmi-14c-back-cover"},
{"l":"13C 5G","u":"/collections/redmi-13c-5g-back-cover"},
{"l":"13","u":"/collections/redmi-13-back-cover"},
{"l":"12C","u":"/collections/redmi-12c-back-cover"},
{"l":"12 5G","u":"/collections/redmi-12-5g-back-cover"},
{"l":"12 4G","u":"/collections/redmi-12-4g-back-cover"},
{"l":"10 Prime","u":"/collections/redmi-10-prime-back-cover"},
{"l":"10 Power","u":"/collections/redmi-10-power-back-cover"},
{"l":"10C","u":"/collections/redmi-10c-back-cover"},
{"l":"10","u":"/collections/redmi-10-back-cover"},
{"l":"9 Power","u":"/collections/redmi-9-power-back-cover"},
{"l":"9T","u":"/collections/redmi-9t-back-cover"},
{"l":"9i","u":"/collections/redmi-9i-back-cover"},
{"l":"9","u":"/collections/redmi-9-back-cover"},
// -- Not in OptionsExport CSV (kept, disabled) --
// {"l":"10A","u":"/collections/redmi-10a-back-cover"},
// {"l":"11 Prime 4G","u":"/collections/redmi-11-prime-4g-back-cover"},
// {"l":"11 Prime 5G","u":"/collections/redmi-11-prime-5g-back-cover"},
// {"l":"13C 4G","u":"/collections/redmi-13c-4g-back-cover"},
// {"l":"14R","u":"/collections/redmi-14r-back-cover"},
// {"l":"A1 Plus","u":"/collections/redmi-a1-plus-back-cover"},
// {"l":"K40 Gaming","u":"/collections/redmi-k40-gaming-back-cover"},
// {"l":"Note 11 Pro","u":"/collections/redmi-note-11-pro-back-cover"},
// {"l":"Note 12S","u":"/collections/redmi-note-12s-back-cover"},
// {"l":"Note 13 4G","u":"/collections/redmi-note-13-4g-back-cover"},
// {"l":"Note 14 5G","u":"/collections/redmi-note-14-5g-back-cover"},
],

"Poco": [
{"l":"X7 Pro","u":"/collections/poco-x7-pro-back-cover"},
{"l":"X7","u":"/collections/poco-x7-back-cover"},
{"l":"X6 Pro","u":"/collections/poco-x6-pro-back-cover"},
{"l":"X6","u":"/collections/poco-x6-back-cover"},
{"l":"X5 Pro","u":"/collections/poco-x5-pro-back-cover"},
{"l":"X5","u":"/collections/poco-x5-back-cover"},
{"l":"X4 Pro","u":"/collections/poco-x4-pro-back-cover"},
{"l":"X4 GT","u":"/collections/poco-x4-gt-back-cover"},
{"l":"X3 Pro","u":"/collections/poco-x3-pro-back-cover"},
{"l":"X3","u":"/collections/poco-x3-back-cover"},
{"l":"M7 Pro","u":"/collections/poco-m7-pro-back-cover"},
{"l":"M7 5G","u":"/collections/poco-m7-5g-back-cover"},
{"l":"M6 Pro 5G","u":"/collections/poco-m6-pro-5g-back-cover"},
{"l":"M6 5G","u":"/collections/poco-m6-5g-back-cover"},
{"l":"M4 Pro 5G","u":"/collections/poco-m4-pro-5g-back-cover"},
{"l":"M4 Pro 4G","u":"/collections/poco-m4-pro-4g-back-cover"},
{"l":"F7","u":"/collections/poco-f7-back-cover"},
{"l":"F6","u":"/collections/poco-f6-back-cover"},
{"l":"F5","u":"/collections/poco-f5-back-cover"},
{"l":"F4","u":"/collections/poco-f4-back-cover"},
{"l":"F3","u":"/collections/poco-f3-back-cover"},
{"l":"C71","u":"/collections/poco-c71-back-cover"},
{"l":"C61","u":"/collections/poco-c61-back-cover"},
{"l":"C55","u":"/collections/poco-c55-back-cover"},
{"l":"C31","u":"/collections/poco-c31-back-cover"},
// -- Not in OptionsExport CSV (kept, disabled) --
// {"l":"C50","u":"/collections/poco-c50-back-cover"},
// {"l":"C51","u":"/collections/poco-c51-back-cover"},
// {"l":"C65","u":"/collections/poco-c65-back-cover"},
// {"l":"F3 GT","u":"/collections/poco-f3-gt-back-cover"},
// {"l":"M4","u":"/collections/poco-m4-back-cover"},
// {"l":"M5","u":"/collections/poco-m5-back-cover"},
// {"l":"M5S","u":"/collections/poco-m5s-back-cover"},
]

};